import React, { useEffect, useState } from "react";
import { Loader2, Gift } from "lucide-react";
import api from "@/lib/api";

export default function AdminReferralPartners() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");

  const load = () => api.get("/admin/referral-partners").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const fmt = (n) => "$" + Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  if (!rows) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-gold" /></div>;

  const filtered = rows.filter((r) => {
    const s = (r.name + r.email + r.company + r.code).toLowerCase();
    return s.includes(q.toLowerCase());
  });
  const totalEarned = rows.reduce((a, r) => a + (r.earned_total || 0), 0);

  return (
    <div data-testid="admin-referral-partners">
      <div className="flex items-center gap-2">
        <Gift className="w-5 h-5 text-gold" />
        <h1 className="font-display text-3xl text-white">Referral Partners</h1>
      </div>
      <p className="mt-2 text-dim text-sm">Every registered user is a referral partner. Tiers are automatic based on funded deals — Standard (1–9), Mid-Tier (10–24), Strategic (25+). Payouts accrue on funded deals (1.75% Bullseye fee × tier).</p>

      <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 gap-3">
        <div className="card-surface rounded-xl p-4"><div className="text-2xl font-display text-white">{rows.length}</div><div className="text-xs text-faint">Partners</div></div>
        <div className="card-surface rounded-xl p-4"><div className="text-2xl font-display text-white">{rows.reduce((a, r) => a + r.total, 0)}</div><div className="text-xs text-faint">Total Referrals</div></div>
        <div className="card-surface rounded-xl p-4"><div className="text-2xl font-display text-gold">{fmt(totalEarned)}</div><div className="text-xs text-faint">Total Earned (funded)</div></div>
      </div>

      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search partners…" data-testid="referral-partners-search"
        className="mt-4 w-full sm:w-80 rounded-lg bg-surface/70 border border-edge text-white text-sm px-3 h-11" />

      <div className="mt-4 overflow-x-auto rounded-xl border border-edge">
        <table className="w-full text-sm min-w-[760px]">
          <thead>
            <tr className="text-left text-faint bg-surface/60 border-b border-edge">
              <th className="py-2.5 px-3 font-semibold">Partner</th>
              <th className="py-2.5 px-3 font-semibold">Code</th>
              <th className="py-2.5 px-3 font-semibold">Referrals</th>
              <th className="py-2.5 px-3 font-semibold">Funded</th>
              <th className="py-2.5 px-3 font-semibold">Earned</th>
              <th className="py-2.5 px-3 font-semibold">Tier</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.user_id} className="border-b border-edge/50" data-testid={`partner-row-${r.code}`}>
                <td className="py-2.5 px-3">
                  <div className="text-white font-medium">{r.name || "—"}</div>
                  <div className="text-xs text-faint">{r.email}{r.company ? ` · ${r.company}` : ""}</div>
                </td>
                <td className="py-2.5 px-3 text-gold font-mono">{r.code}</td>
                <td className="py-2.5 px-3 text-white/85">{r.total}</td>
                <td className="py-2.5 px-3 text-white/85">{r.funded}</td>
                <td className="py-2.5 px-3 text-ok font-semibold">{fmt(r.earned_total)}</td>
                <td className="py-2.5 px-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-semibold border border-gold/40 bg-gold/10 text-gold" data-testid={`partner-tier-${r.code}`}>{r.tier_label}</span>
                  <div className="text-[11px] text-faint mt-1">{r.tier_range}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
